import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@clerk/react";
import { toast } from "sonner";
import { useChatStore } from "@/stores";

/**
 * One-click "with Amy" deep link: reserve a chat conversation with a
 * prefilled first message, then open it. The thread component sends
 * `pendingFirstMessage` automatically on mount (chatStore.createConversation
 * contract), so the decision flow (phase review verdicts, payout confirms,
 * gate releases, handoff answers) continues in the Amy chat with its native
 * approval buttons.
 */
export function useAmyDeepLink() {
  const navigate = useNavigate();
  const { getToken } = useAuth();
  const createConversation = useChatStore((s) => s.createConversation);

  return useCallback(
    async (prefill: string) => {
      const token = await getToken();
      if (!token) {
        toast.error("Couldn't open the Amy chat — please sign in again.");
        return;
      }
      const id = await createConversation(prefill, token);
      if (!id) {
        toast.error("Couldn't start the Amy chat.");
        return;
      }
      navigate(`/dashboard/amy/${id}`);
    },
    [createConversation, getToken, navigate]
  );
}
